const goalieColumns = [
    {
        accessorKey: 'team.league.league_name',
        header: 'League',
        size: 20, //small column
    },
    {
        accessorKey: 'team.team_name',
        header: 'Team',
        size: 20, //small column
    },
    {
        accessorKey: 'year',
        header: 'Year',
        size: 20, //small column
        Cell: ({ cell, row }) => {return ((row.original.is_playoff))? row.original.year + " Playoffs" : row.original.year;}
    },
    {
        accessorKey: 'games_played',
        header: 'GP',
        size: 50, //small column
    },
    {
        accessorKey: 'record',
        header: 'W-L-T',
        size: 50, //small column
    },
    {
        accessorKey: 'goals_against_average',
        header: 'GAA',
        size: 50, //small column
    },
    {
        accessorKey: 'save_percentage',
        header: 'SV%',
        size: 50, //small column
    },
    {
        accessorKey: 'shutouts',
        header: 'SO',
        size: 50, //small column
    },
    {
        accessorKey: 'penalty_minutes',
        header: 'PIM',
        size: 50, //small column

    },
]

const playerColumns = [
    {
        accessorKey: 'team.league.league_name',
        header: 'League',
        size: 20, //small column
    },
    {
        accessorKey: 'team.team_name',
        header: 'Team',
        size: 20, //small column
    },
    {
        accessorKey: 'year',
        header: 'Year',
        size: 20, //small column
        Cell: ({ cell, row }) => {return ((row.original.is_playoff))? row.original.year + " Playoffs" : row.original.year;}
    },
    {
        accessorKey: 'games_played',
        header: 'GP',
        size: 50, //small column
    },
    {
        accessorKey: 'goals',
        header: 'G',
        size: 50, //small column
    },
    {
        accessorKey: 'assists',
        header: 'A',
        size: 50, //small column
    },
    {
        header: 'PTS',
        size: 50, //small column
        Cell: ({ cell, row }) => {return (row.original.goals + row.original.assists)}

    },
    {
        header: 'PPG',
        size: 50, //small column
        Cell: ({ cell, row }) => {return parseFloat((row.original.goals + row.original.assists)/row.original.games_played).toFixed(2);}
    },
    {
        accessorKey: 'penalty_minutes',
        header: 'PIM',
        size: 50, //small column

    },

]

const nhlSkaterColumns = [
    {
        accessorKey: 'league_name',
        header: 'League',
        size: 20,
    },
    {
        accessorKey: 'team_name',
        header: 'Team',
        size: 20,
    },
    {
        accessorKey: 'year',
        header: 'Season',
        size: 20,
    },
    {
        accessorKey: 'games_played',
        header: 'GP',
        size: 50,
    },
    {
        accessorKey: 'goals',
        header: 'G',
        size: 50,
    },
    {
        accessorKey: 'assists',
        header: 'A',
        size: 50,
    },
    {
        accessorKey: 'points',
        header: 'PTS',
        size: 50,
    },
    {
        header: 'PPG',
        size: 50,
        Cell: ({ row }) => {
            const gp = row.original.games_played;
            const pts = row.original.points;
            if (!gp) return '—';
            return parseFloat(pts / gp).toFixed(2);
        },
    },
    {
        accessorKey: 'plus_minus',
        header: '+/-',
        size: 50,
    },
    {
        accessorKey: 'penalty_minutes',
        header: 'PIM',
        size: 50,
    },
];

const nhlGoalieColumns = [
    {
        accessorKey: 'league_name',
        header: 'League',
        size: 20,
    },
    {
        accessorKey: 'team_name',
        header: 'Team',
        size: 20,
    },
    {
        accessorKey: 'year',
        header: 'Season',
        size: 20,
    },
    {
        accessorKey: 'games_played',
        header: 'GP',
        size: 50,
    },
    {
        accessorKey: 'record',
        header: 'W-L-OT',
        size: 50,
    },
    {
        accessorKey: 'goals_against_average',
        header: 'GAA',
        size: 50,
        Cell: ({ row }) => {
            const gaa = row.original.goals_against_average;
            if (gaa == null || gaa === '') return '—';
            return parseFloat(gaa).toFixed(2);
        },
    },
    {
        accessorKey: 'save_percentage',
        header: 'SV%',
        size: 50,
        Cell: ({ row }) => {
            const sv = row.original.save_percentage;
            if (sv == null || sv === '') return '—';
            const value = parseFloat(sv);
            if (!Number.isFinite(value)) return sv;
            return value >= 1 ? value.toFixed(3) : `.${String(Math.round(value * 1000)).padStart(3, '0')}`;
        },
    },
    {
        accessorKey: 'shutouts',
        header: 'SO',
        size: 50,
    },
    {
        accessorKey: 'penalty_minutes',
        header: 'PIM',
        size: 50,
    },
];

export { goalieColumns, playerColumns, nhlSkaterColumns, nhlGoalieColumns };